import Big from 'big.js';

// The API stores the destination amount and the rate in destination units per source unit.
export const conversionSourceAmount = (
  amount?: number | string | null,
  rate?: number | string | null,
) => {
  if (
    amount == null ||
    rate == null ||
    !Number.isFinite(Number(amount)) ||
    !Number.isFinite(Number(rate)) ||
    Number(rate) <= 0
  )
    return null;
  return Number(new Big(amount).div(rate).toString());
};

export const inverseConversionRate = (rate?: number | string | null) => {
  if (rate == null || !Number.isFinite(Number(rate)) || Number(rate) <= 0) return null;
  return Number(new Big(1).div(rate).toString());
};
